import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, Grid, Input, Slider, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    width: 250,
  },
  input: {
    width: 42,
  },
});

const EditMaterial = (props) => {
  const classes = useStyles();
  const [open1, setOpen1] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const { t } = useTranslation('work_order');
  const [value, setValue] = React.useState(1);
  const handleCloseP = () => {
    setOpen1(false);
  };

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    setValue(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    } else if (value > props.max) {
      setUyari(`${t('lblMaxAdet')} ${props.max} ${t('Adet')}`);
      setOpen1(true);
      setValue(props.max);
    }
  };

  useEffect(() => {
    setValue(1);
  }, [props.materialCode]);


  const handleClose = () => {
    props.onClose(value);
  };


  return (
    <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <Dialog
        open={open1}
        onClose={handleCloseP}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseP} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <DialogTitle id="form-dialog-title">{`${props.materialCode} ${props.materialDesc}`}</DialogTitle>
      <DialogContent>

        <div className={classes.root}>
          <Typography id="input-slider" gutterBottom>
            {t('lblMiktar')}
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs>
              <Slider
                min={props.min}
                max={20}
                value={typeof value === 'number' ? value : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={value}
                margin="dense"
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 1,
                  min: 0,
                  max: 20,
                  type: 'number',
                  'aria-labelledby': 'input-slider',
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
          <Grid item>
              <p style={{color:'red', fontWeight:'bold',marginTop:'5px'}}>{`${props.sparePartMessage}`}</p>
            </Grid>
          </Grid>
        </div>


      </DialogContent>
      <DialogActions>
        <Fab
          color="secondary"
          aria-label="add"
          // color="primary"
          component="span"
          onClick={handleClose}
        >
          <DoneIcon />
        </Fab>
      </DialogActions>
    </Dialog>

  );
};

export default (EditMaterial);
